import api from "./api";
import { API_MOBILE_SERVER_TASKS } from "../constants/urls";


export const serverTask = {
    getAll: async () => (await api.get(API_MOBILE_SERVER_TASKS)).data,
    getById: async (id) => (await api.get(`${API_MOBILE_SERVER_TASKS}/${id}`)).data,
    update: async (serverTask) =>
        (await api.put(`${API_MOBILE_SERVER_TASKS}/${serverTask.id}`, serverTask)).data,
};